export const UTM_SOURCE_PARAM = "utm_source";
export const UTM_MEDIUM_PARAM = "utm_medium";
export const UTM_CAMPAIGN_PARAM = "utm_campaign";
export const UTM_TERM_PARAM = "utm_term";
export const UTM_CONTENT_PARAM = "utm_content";

// Order matters: the same list drives parsing and handoff forwarding so a
// param added here flows end to end without touching either call site.
export const UTM_PARAMS = [
  UTM_SOURCE_PARAM,
  UTM_MEDIUM_PARAM,
  UTM_CAMPAIGN_PARAM,
  UTM_TERM_PARAM,
  UTM_CONTENT_PARAM,
] as const;
